module.exports = __webpack_public_path__ + "img/spring.3f1b8c65.svg";